import React from 'react';
import styles from './NoAccess.less';

export default () => (
  <div className={styles.wrap}>
    <h1>No Access</h1>
    <p>You do not have permission to access this section</p>
  </div>
);
